module.exports = {"421221100":"陆溪镇","421221101":"高铁岭镇","421221102":"官桥镇","421221103":"鱼岳镇","421221104":"新街镇","421221105":"渡普镇","421221106":"潘家湾镇","421221107":"牌洲湾镇","421221450":"头墩农场","421221570":"嘉鱼县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421221.json
// module id = 1632
// module chunks = 0